import { StripeService } from '@app/core/services/stripe.service';
import { ConfirmationModalComponent } from './../../../../infrastructure/shared/components/confirmation-modal/confirmation-modal.component';
import { takeUntil } from 'rxjs/operators';
import { StripePayoutSettingsComponent } from './../stripe/stripe-payout-settings/stripe-payout-settings.component';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { Observable } from 'rxjs';
import { AddCardComponent } from '../stripe/add-card/add-card.component';
import { StripeAccountComponent } from '../stripe/stripe-account/stripe-account.component';
import { StripeExternalComponent } from '../stripe/stripe-external/stripe-external.component';
import { AuthService } from '@app/core/auth/auth.service';
import { PaymentSourceService } from '@app/core/services/payment-source.service';
import { TermsOfAgreementComponent } from '@app/shared/components/terms-of-agreement/terms-of-agreement.component';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-stripe-settings',
  templateUrl: './stripe-settings.component.html',
  styleUrls: ['./stripe-settings.component.scss']
})
export class StripeSettingsComponent implements OnInit, OnDestroy {
  userSubscription: any;
  processLoading = false;
  haveStripeAccount = false;

  isFirstTimeLoad = true;
  private email: string;
  template = null;
  stripeAccountDetails: any;
  // use to house stripe account information
  stripeAccountDetails$: Observable<any>;
  // use to house stripe customer information
  stripeSource$: Observable<any>;

  public mainTemplateRef: TemplateRef<any>;

  @ViewChild('paymentTemplate')
  private setPaymentTemplateRef: TemplateRef<any>;

  @ViewChild('payoutTemplate')
  private payOutTemplateRef: TemplateRef<any>;
  openPayoutMethodByDefault = false;
  stripe_account_ID: string;
  constructor(
    private authService: AuthService,
    private ngbModal: NgbModal,
    private fun: AngularFireFunctions,
    private notifierService: NotifierService,
    private paymentSource: PaymentSourceService,
    private activateRoute: ActivatedRoute,
    private locationSrv: Location,
    private stripeService: StripeService
  ) {
    const queryParams = this.activateRoute.snapshot.queryParams;
    if (queryParams.checkStripeAccount) {
      this.openPayoutMethodByDefault = true;
      this.locationSrv.replaceState(window.location.pathname);
    }

  }

  async ngOnInit() {
    this.mainTemplateRef = this.setPaymentTemplateRef;
    this.processLoading = true;
    this.userSubscription = this.authService.user.subscribe(async user => {
      this.email = user.email;
      this.stripe_account_ID = user.stripe_account_ID;
      if (user && !!user.stripe_account_ID) {
        // control for existence of stripe account based on db data
        this.haveStripeAccount = !!user.stripe_account_ID;
        try {
          // retrieve stipe account info
          this.stripeAccountDetails = await this.fun.httpsCallable('getStripeAccount')({
            accountId: user.stripe_account_ID
          }).toPromise();
          this.processLoading = false;
          if (this.isFirstTimeLoad) {
            this.loadSetPayment();
          }
        } catch (error) {
          this.notifierService.notify('error', 'Failed to Create Customer' + error);
          this.processLoading = false;
        }
      } else {
        this.processLoading = false;
      }

      if (this.openPayoutMethodByDefault) {
        this.loadSetPayout();
        this.openPayoutMethodByDefault = false;
      }
      this.isFirstTimeLoad = false;
    });

    // assign the list of sources for cards
    this.stripeSource$ = this.paymentSource.cards;
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

  loadSetPayment() {
    // todo open modal for creation of card
    this.mainTemplateRef = this.setPaymentTemplateRef;
    this.stripeSource$ = this.paymentSource.cards;
  }

  testTos() {
    const stripeAccountModal = this.ngbModal.open(TermsOfAgreementComponent);
    stripeAccountModal.componentInstance.email = this.email;
    stripeAccountModal.componentInstance.stripe_account_ID = this.stripe_account_ID;

    stripeAccountModal.componentInstance.result.subscribe(result => {
      this.ngbModal.dismissAll();
    });
  }

  loadSetPayout() {
    setTimeout(() => {
      if (!this.haveStripeAccount) {
        const stripeAccountModal = this.ngbModal.open(TermsOfAgreementComponent, {
          windowClass: 'terms-modal'
        });
        stripeAccountModal.componentInstance.email = this.email;
        stripeAccountModal.componentInstance.result.subscribe(result => {
          if (result === 201) {
            this.mainTemplateRef = this.payOutTemplateRef;
            // todo Success message
          } else {
            // todo Failure message
          }
          this.ngbModal.dismissAll();
        });
      } else {
        this.mainTemplateRef = this.payOutTemplateRef;
      }
    }, 500);
  }

  setPaymentMethod() {
    const result = this.ngbModal
      .open(AddCardComponent, {
        windowClass: 'stripe-account-modal',
        centered: true,
        size: 'md'
      })
      .result.then(data => {
        this.ngbModal.dismissAll();
        return;
      })
      .catch(error => {
        return;
      });
  }

  openAddBankAccountModal() {
    const stripeAccountModal = this.ngbModal.open(StripeExternalComponent, {
      windowClass: 'stripe-account-modal'
    });

    // stripeAccountModal.componentInstance.result.subscribe(result => {
    //   this.ngbModal.dismissAll();
    //   // this.router.navigate(['/profile/stripe-account-info']);
    // });
  }

  openAccountInfo() {
    const stripeAccountModal = this.ngbModal.open(StripeAccountComponent, {
      windowClass: 'stripe-account-modal'
    }
    );

    stripeAccountModal.componentInstance.result.subscribe(result => {
      this.processLoading = true;
      if (result === 201) {
        this.ngbModal.dismissAll();
        this.processLoading = false;
      }
    });
  }

  async deleteCard(event) {
    const { id, fingerprint } = event;
    this.processLoading = true;
    try {
      const data = {
        card_Id: id,
        fingerprint
      };
      const result = await this.fun.httpsCallable('deleteStripeCard')(data).toPromise();
      // successfull delete
      this.processLoading = false;
    } catch (error) {
      console.log('deleteCarderror:', error);
      this.processLoading = false;
    }
  }

  setDefaultExternalAccount(accountId) {
    this.processLoading = true;
    try {
      this.stripeAccountDetails$ = this.fun.httpsCallable('setDefaultExternalBank')({
        accountId
      });
      if (this.stripeAccountDetails$) {
        //
      }
    } catch (error) {
      // error notify
      console.log('error occured');
    }
    this.processLoading = false;
  }

  deleteExternalAccount(accountId) {
    this.processLoading = true;
    this.stripeAccountDetails$ = this.fun.httpsCallable('deleteExternalBank')({
      accountId
    });
    this.processLoading = false;
  }

  openPayoutAccoutSettings() {
    const beforeDismissCallback = async (
      ref: NgbModalRef,
      dismissFlag: Promise<boolean> | boolean
    ) => {
      let allowDismiss = await dismissFlag;

      if (allowDismiss) {
        return allowDismiss;
      } else {
        const confirmationModalRef = this.ngbModal.open(
          ConfirmationModalComponent,
          {
            centered: true
          }
        );

        confirmationModalRef.componentInstance.message = 'You have unsaved changes. Proceed to discard changes?';
        confirmationModalRef.componentInstance.cancelLabel = 'Discard';
        confirmationModalRef.componentInstance.okLabel = 'Cancel';

        confirmationModalRef.componentInstance.onAccept
          .pipe(takeUntil(confirmationModalRef.closed))
          .subscribe(() => {
            confirmationModalRef.close();
          });

        confirmationModalRef.componentInstance.onClose
          .pipe(takeUntil(confirmationModalRef.closed))
          .subscribe(() => {
            ref.close();
            confirmationModalRef.close();
          });
      }
      return allowDismiss;
    };

    const stripeAccountModal = this.ngbModal.open(
      StripePayoutSettingsComponent,
      {
        // backdrop: 'static',
        // keyboard: false,
        windowClass: 'stripe-account-modal',
        beforeDismiss: () => beforeDismissCallback(
          stripeAccountModal,
          stripeAccountModal.componentInstance.allowDismiss$
        )
      }
    );

    stripeAccountModal.componentInstance.modalRef = stripeAccountModal;

    // stripeAccountModal.dismissed
    //   .subscribe(dis => {
    //     console.log('dis', dis);
    //   });

    // stripeAccountModal.closed
    //   .subscribe(closed => {
    //     console.log('closed', closed);
    //   });
  }
  
  showTermsButton(stripeAccountData) {
    return this.stripeService.accountHasNotAcceptedTerms(stripeAccountData);
  }

}
